import { ICustomerRefundRequest } from '../../types/store';
import {
  IGetAllRefundRequestsResponse,
  IProcessRefundResponse,
} from '../../types/api/response/customerRefundResponse';
import { IProcessRefundRequest } from '../../types/api/request/customerRefundRequest.d';

// ---------------------------------------------------------------------------
// Mock data — replace axiosClient calls once the real endpoint is available
// ---------------------------------------------------------------------------
const mockRefunds: ICustomerRefundRequest[] = [
  {
    id: 1,
    order_number: 'ORD-2024-001',
    customer_name: 'Maria Santos',
    customer_email: 'maria.santos@email.com',
    customer_phone: '+63 912 345 6789',
    refund_amount: 1250.0,
    reason:
      'Received damaged item. The packaging was torn and the product inside was broken upon delivery.',
    status: 'PENDING',
    payment_method: 'GCash',
    created_at: '2024-03-10T08:30:00Z',
    updated_at: null,
    processed_by: null,
    notes: null,
  },
  {
    id: 2,
    order_number: 'ORD-2024-002',
    customer_name: 'Juan dela Cruz',
    customer_email: 'juan.delacruz@email.com',
    customer_phone: '+63 917 234 5678',
    refund_amount: 3500.0,
    reason: 'Wrong item delivered. Ordered a blue variant but received red.',
    status: 'APPROVED',
    payment_method: 'Credit Card',
    created_at: '2024-03-09T10:15:00Z',
    updated_at: '2024-03-10T14:00:00Z',
    processed_by: 'admin@superstore.com',
    notes: 'Verified with warehouse. Approved full refund.',
  },
  {
    id: 3,
    order_number: 'ORD-2024-003',
    customer_name: 'Ana Reyes',
    customer_email: 'ana.reyes@email.com',
    customer_phone: '+63 920 876 5432',
    refund_amount: 750.0,
    reason: 'Item not delivered after 7 days. Tracking shows no movement.',
    status: 'PROCESSING',
    payment_method: 'Maya',
    created_at: '2024-03-08T09:00:00Z',
    updated_at: '2024-03-09T11:30:00Z',
    processed_by: 'supervisor@superstore.com',
    notes: 'Coordinating with logistics team.',
  },
  {
    id: 4,
    order_number: 'ORD-2024-004',
    customer_name: 'Pedro Lim',
    customer_email: 'pedro.lim@email.com',
    customer_phone: '+63 905 432 1098',
    refund_amount: 2200.0,
    reason: 'Product defective on arrival. The device does not turn on.',
    status: 'REJECTED',
    payment_method: 'Cash on Delivery',
    created_at: '2024-03-07T13:45:00Z',
    updated_at: '2024-03-08T09:00:00Z',
    processed_by: 'admin@superstore.com',
    notes: 'COD orders are non-refundable per policy. Customer advised to use warranty.',
  },
  {
    id: 5,
    order_number: 'ORD-2024-005',
    customer_name: 'Rosa Flores',
    customer_email: 'rosa.flores@email.com',
    customer_phone: '+63 999 111 2233',
    refund_amount: 580.0,
    reason: 'Duplicate charge on my GCash account for a single order.',
    status: 'PENDING',
    payment_method: 'GCash',
    created_at: '2024-03-11T07:20:00Z',
    updated_at: null,
    processed_by: null,
    notes: null,
  },
  {
    id: 6,
    order_number: 'ORD-2024-006',
    customer_name: 'Carlos Mendoza',
    customer_email: 'carlos.mendoza@email.com',
    customer_phone: '+63 916 555 7788',
    refund_amount: 4800.0,
    reason: 'Cancelled order before dispatch but was still charged.',
    status: 'APPROVED',
    payment_method: 'Debit Card',
    created_at: '2024-03-06T16:10:00Z',
    updated_at: '2024-03-07T08:45:00Z',
    processed_by: 'admin@superstore.com',
    notes: 'Order cancellation confirmed. Full refund processed.',
  },
  {
    id: 7,
    order_number: 'ORD-2024-007',
    customer_name: 'Liza Tan',
    customer_email: 'liza.tan@email.com',
    customer_phone: '+63 918 900 0011',
    refund_amount: 1100.0,
    reason: 'Item expired before the printed expiry date.',
    status: 'PENDING',
    payment_method: 'Maya',
    created_at: '2024-03-11T11:05:00Z',
    updated_at: null,
    processed_by: null,
    notes: null,
  },
  {
    id: 8,
    order_number: 'ORD-2024-008',
    customer_name: 'Roberto Garcia',
    customer_email: 'roberto.garcia@email.com',
    customer_phone: '+63 908 321 6655',
    refund_amount: 950.0,
    reason: 'Received only 2 out of 3 items in the bundle.',
    status: 'PROCESSING',
    payment_method: 'GCash',
    created_at: '2024-03-10T14:30:00Z',
    updated_at: '2024-03-11T09:15:00Z',
    processed_by: 'supervisor@superstore.com',
    notes: 'Requesting fulfillment report from warehouse.',
  },
];

let mockData = [...mockRefunds];

export const CustomerRefundService = {
  async getAllRefundRequests(): Promise<IGetAllRefundRequestsResponse> {
    // Replace with: const res = await axiosClient.get<IGetAllRefundRequestsResponse>(CustomerRefundEndpoints.GET_ALL_REFUND_REQUESTS);
    // return res.data;
    return Promise.resolve({
      content: mockData,
      page: {
        size: mockData.length,
        number: 0,
        totalElements: mockData.length,
        totalPages: 1,
      },
    });
  },

  async processRefundRequest(
    id: number,
    payload: IProcessRefundRequest,
  ): Promise<IProcessRefundResponse> {
    // Replace with:
    // const url = CustomerRefundEndpoints.PROCESS_REFUND_REQUEST.replace(':id', id.toString());
    // const res = await axiosClient.put<IProcessRefundResponse>(url, payload);
    // return res.data;
    const index = mockData.findIndex((r) => r.id === id);
    if (index === -1) throw new Error('Refund request not found');
    mockData[index] = {
      ...mockData[index],
      status: payload.status,
      notes: payload.notes,
      updated_at: new Date().toISOString(),
      processed_by: 'admin@superstore.com',
    };
    return Promise.resolve({ ...mockData[index] });
  },
};
